import { get, writable } from "svelte/store";
import { getCredentialsForIceServers } from "../services/iceServers";
import { getStunChoice } from "../utils/getStunChoice";
import { getWebRTCConfiguration } from "../utils/getWebRTCConfiguration";
import { buildLog } from "../utils/log";
import { ROOM_CONNECTION_STATE } from "../types/Room/RoomConnectionState";
import { sendSocketMessage } from "./socketStore";
import { getRoom } from "./roomStore";
import { localVideoStore } from "./localVideoStore";
import "./toastStore";
export const peerConnectionWithExpertStore = writable(null);
export const pendingIceWithExpertStore = writable([]);
export async function createPeerConnectionWithExpert(roomId) {
    console.log("[peerConnectionWithExpert] createPeerConnection roomId", roomId);
    const oldPc = get(peerConnectionWithExpertStore);
    if (oldPc) {
        oldPc.close();
        peerConnectionWithExpertStore.set(null);
    }
    const credentials = await getCredentialsForIceServers();
    const stunChoice = getStunChoice(roomId);
    const configuration = getWebRTCConfiguration(roomId, credentials);
    const pc = new RTCPeerConnection(configuration);
    buildLog({
        roomId,
        status: ROOM_CONNECTION_STATE.CONNECTING,
        page: "Camera",
        message: `peerConnectionWithExpert created using server: ${stunChoice}.sd-sfr.fr`
    });
    const localStream = get(localVideoStore);
    if (localStream) {
        localStream.getTracks().forEach(track => {
            pc.addTrack(track, localStream);
            console.log(`[peerConnectionWithExpert] added local track: ${track.kind}`);
        });
    }
    pc.onicecandidate = (e) => {
        if (e.candidate) {
            console.log('[peerConnectionWithExpert] onicecandidate');
            sendSocketMessage({
                room: getRoom().id,
                action: "ice",
                type: "candidate",
                label: e.candidate.sdpMLineIndex,
                id: e.candidate.sdpMid,
                candidate: e.candidate.candidate,
                target: "expert",
                connectionType: "expert",
            });
        }
    };
    pendingIceWithExpertStore.set([]);
    peerConnectionWithExpertStore.set(pc);
}
export async function createOfferWithExpert() {
    const pc = get(peerConnectionWithExpertStore);
    if (!pc)
        return console.warn("[video] peerConnection not ready");
    const offer = await pc.createOffer();
    await pc.setLocalDescription(offer);
    sendSocketMessage({
        room: getRoom().id,
        action: "ICEOffer",
        type: "connection",
        target: "expert",
        sdp: offer,
        connectionType: "expert",
    });
}
export async function handleAnswerWithExpert(sdp) {
    if (!sdp || !sdp.sdp || !sdp.type) {
        console.warn("handleOffer: invalid SDP", sdp);
        return;
    }
    const pc = get(peerConnectionWithExpertStore);
    if (!pc)
        return;
    await pc.setRemoteDescription(new RTCSessionDescription(sdp));
    const pending = get(pendingIceWithExpertStore);
    for (const c of pending)
        await pc.addIceCandidate(c);
    pendingIceWithExpertStore.set([]);
}
export async function addIceCandidateWithExpert(data) {
    const pc = get(peerConnectionWithExpertStore);
    if (!pc)
        return;
    const candidate = new RTCIceCandidate({ candidate: data.candidate, sdpMid: data.id, sdpMLineIndex: data.label });
    if (!pc.remoteDescription)
        pendingIceWithExpertStore.update(l => [...l, candidate]);
    else
        await pc.addIceCandidate(candidate);
}
export function closePeerConnectionWithExpert() {
    const pc = get(peerConnectionWithExpertStore);
    if (!pc)
        return;
    pc.getSenders().forEach(sender => { var _a; return (_a = sender.track) === null || _a === void 0 ? void 0 : _a.stop(); });
    pc.close();
    peerConnectionWithExpertStore.set(null);
}
